// HACK: copied from Next.js to support multiple dataLayer "config"
// https://github.com/vercel/next.js/blob/canary/packages/third-parties/src/google/gtm.tsx
import Script from 'next/script';

import { stripNulls } from '@/helpers/formatters';
import { AdEvents, EventData, TrackingEvent } from '@/helpers/tracking';

import { normalizeAddress, normalizeEmail, normalizePhone } from './normalizers';

export const GoogleTagManager = () => {
  const gtmId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;
  const tagIds = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_CONFIG?.split(',') ?? [];

  if (!gtmId) {
    return null;
  }

  return (
    <>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
          (function(w,l){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});

            function gtag(){w[l].push(arguments);}
            ${tagIds.map((tagId) => `gtag('config', '${tagId}')`).join(';')}
          })(window,'dataLayer');`,
        }}
        id="gtm-init"
      />
      <Script data-ntpc="GTM" id="gtm" src={`https://www.googletagmanager.com/gtm.js?id=${gtmId}`} />
    </>
  );
};

export const trackGoogleConversion = (eventName: TrackingEvent, data?: EventData) => {
  const { googleAdLabel } = AdEvents[eventName] ?? {};

  if (!window?.gtag || !googleAdLabel) {
    return;
  }

  const address = normalizeAddress(data?.address);
  const email = normalizeEmail(data?.email);
  const phone = normalizePhone(data?.phone);

  // Send conversion event
  const conversionData = stripNulls({
    currency: 'USD',
    email,
    send_to: `AW-10940956840/${googleAdLabel}`,
    value: 1,
  });

  window.gtag('event', 'conversion', conversionData);

  // Send user data
  const userData = stripNulls({ address, email, phone_number: phone });

  if (Object.keys(userData).length > 0) {
    window.gtag('set', 'user_data', userData);
  }
};
